import { Controller } from "@hotwired/stimulus"
import { createIcons, Eye, EyeOff } from "lucide"

const icons = { Eye, EyeOff }
// Stimulus controller untuk toggle password + icon lucide
export default class extends Controller {
  static targets = ["input", "iconContainer"]

  connect() {
    createIcons({ icons })
  }

  toggle(event) {
    event.preventDefault()
    const input = this.inputTarget
    const container = this.iconContainerTarget

    // toggle tipe input
    const willShow = input.type === "password"
    input.type = willShow ? "text" : "password"

    // buat ulang <i> dengan atribut data-lucide yang sesuai
    const iconName = willShow ? "eye-off" : "eye"
    container.innerHTML = `<i data-lucide="${iconName}"></i>`

    // render ulang ikon lucide untuk elemen <i> baru
    createIcons({ icons })
  }
}
